import { useAccessibleUserAccounts } from "../../Common/HelperComponents/CustomHooks";
import { useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./CustomToast.module.css"; // Import the CSS module

const useActivationNotification = (totalHours) => {
  const accessibleAccounts = useAccessibleUserAccounts();

  useEffect(() => {
    if (!accessibleAccounts?.length) {
      return;
    }

    accessibleAccounts.forEach((account) => {
      if (!account?.activation_date || !account?.accountNumber) {
        return;
      }

      const dismissKey = `activation-toast-dismissed-${account.accountNumber}`;
      if (localStorage.getItem(dismissKey) === "true") {
        return;
      }

      const activationDate =
        new Date(account.activation_date).getTime() -
        new Date(account.activation_date).getTimezoneOffset() * 60000;
      const currentTime = new Date();
      const diffInMs = currentTime - activationDate;
      const diffInHours = diffInMs / (1000 * 60 * 60);

      if (diffInHours <= totalHours) {
        const remainingHours = Math.floor(totalHours - diffInHours);
        const remainingMinutes = Math.floor(
          ((totalHours - diffInHours) * 60) % 60
        );

        const toastId = `activation-toast-${account.accountNumber}`;
        if (!toast.isActive(toastId)) {
          toast.info(
            `Account ${
              account.accountNumber
            } was activated on ${new Date(
              activationDate
            )}. A comprehensive scan is in progress. Your data will be available in approximately ${remainingHours} hours and ${remainingMinutes} minutes.`,
            {
              toastId,
              autoClose: false, // Make the toast sticky
              position: toast.POSITION.TOP_CENTER,
              closeButton: ({ closeToast }) => (
                <button
                  className={styles.customCloseButton}
                  onClick={() => {
                    localStorage.setItem(dismissKey, "true");
                    closeToast();
                  }}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: 700,
                    fontSize: 16,
                  }}
                  aria-label="Close"
                >
                  ×
                </button>
              ),
            }
          );
        }
      }
    });
  }, [accessibleAccounts, totalHours]);
};

export default useActivationNotification;
